import { apiService } from '../api/ApiService';
import { TOKEN_KEY } from '../constants';
import { storageService } from '../storage/StorageService';

const API_BASE = '/api/admin';

class AuthService {
    private getToken(): string | null {
        return storageService.get<string>(TOKEN_KEY);
    }

    private clearToken(): void {
        storageService.remove(TOKEN_KEY);
    }

    public hasToken(): boolean {
        return !!this.getToken();
    }

    public async verify(): Promise<boolean> {
        const token = this.getToken();
        if (!token) return false;

        try {
            await apiService.request(`${API_BASE}/verify`);
            return true;
        } catch {
            this.clearToken();
            return false;
        }
    }
}

export const authService = new AuthService();
